module.exports = __webpack_public_path__ + "static/placement-a0476834d9a031b64a00843447b92f86.png";